
import {defineComponent} from "vue";
import Login from "@/components/views/Login.vue";
import Register from "@/components/views/Register.vue";
import ResetPw from "@/components/views/ResetPw.vue";
import ResetPwResetToken from "@/components/views/ResetPwResetToken.vue";

export default defineComponent({
  name: "LoginPage",
  components: {ResetPwResetToken, ResetPw, Register, Login},
  data () {
    return {
      view: 'login' as 'login' | 'register' | 'reset' | 'resetPwResetToken' ,
    }
  }
})
